import { Exclamation } from 'assets/icons';
import UseContext from 'hooks/useContext';
import { getCountText } from 'components/perimeter/perimeterText';

// Members left without any perimeter see every mission again.
const PerimeterAccessAlert = ({ count }) => {
  const { language } = UseContext();

  return (
    <div
      role={'alert'}
      className={
        'flex items-start gap-3 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700'
      }
    >
      <span aria-hidden={'true'} className={'mt-0.5 shrink-0'}>
        <Exclamation wh={20} color={'#DC2626'} />
      </span>
      <p>{getCountText(language, 'alert.membersAccess', count)}</p>
    </div>
  );
};

export default PerimeterAccessAlert;
